import {notify, NotifyCode} from "./message";
import {patternFloat2} from "./constants";
import {isEmpty} from "./global";
import {Symbol} from "./template";
import {ReactNode} from "react";
import {FORM_TYPE} from "../../components/Basic/InputForm";

export const formValidation = {
    require: (name: string) => {
        return {
            required: true,
            message: `"${name}" is required`
        }
    },
    confirmPassword: () => ({getFieldValue}: any) => ({
        validator(_: any, value: any) {
            if (!value || getFieldValue('password') === value) {
                return Promise.resolve();
            }
            return Promise.reject(new Error('The two passwords that you entered do not match!'));
        },
    })
}

export const Rule = {
    Require: (name: string) => ({required: true, message: notify[NotifyCode.E32]([name])}),
    Requires: (name: string) => ({required: true, message: notify[NotifyCode.E29]([name])}),
    Number: () => ({pattern: new RegExp(patternFloat2), message: notify[NotifyCode.E9]()})
}

export const funcValidation: { [type: string]: (value: any) => NotifyCode | undefined } = {
    require: (value: any) => isEmpty(value) ? NotifyCode.E32 : undefined,
    requireZero: (value: any = 0) => +value ? undefined : NotifyCode.E32,
    requireArray: (value: any) => ((value || []).length > 0) ? undefined : NotifyCode.E32,
}

interface IRuleForm {
    require?: boolean
    requireZero?: boolean
    requireArray?: boolean
}

export interface IFormItemModel {
    label: string,
    rules: IRuleForm,
    type: FORM_TYPE,
    suffix?: string | ReactNode,
}

export interface IFormModel {
    [id: string]: IFormItemModel
}

export const formModel: IFormModel = {
    name: {label: 'Name', type: FORM_TYPE.TEXT, rules: {require: true}},
    max_length: {label: 'Length', type: FORM_TYPE.NUMBER, suffix: 'm', rules: {requireZero: true}},
    max_capacity: {label: 'Capacity', type: FORM_TYPE.NUMBER, suffix: Symbol.m3, rules: {requireZero: true}},
}
